import React, { useState } from "react";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  getDocs,
  writeBatch,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase"; // adapte ton chemin

const PAGE_SIZE = 500;

export default function UpdateDollarStoreToPending() {
  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState("");
  const [updatedCount, setUpdatedCount] = useState(0);

  const run = async () => {
    setLoading(true);
    setLog("");
    setUpdatedCount(0);

    try {
      let lastDoc = null;
      let totalUpdated = 0;
      let loops = 0;

      while (true) {
        loops += 1;

        // ✅ Query: vendorName == "Dollar Store" + pagination stable via __name__
        const qy = lastDoc
          ? query(
              collection(db, "productsShop"),
              where("vendorName", "==", "Dollar Store"),
              orderBy("__name__"),
              startAfter(lastDoc),
              limit(PAGE_SIZE)
            )
          : query(
              collection(db, "productsShop"),
              where("vendorName", "==", "Dollar Store"),
              orderBy("__name__"),
              limit(PAGE_SIZE)
            );

        const snap = await getDocs(qy);

        if (snap.empty) break;

        const batch = writeBatch(db);

        snap.docs.forEach((d) => {
          // ✅ update validationStatus => pending
          batch.update(doc(db, "productsShop", d.id), {
            validationStatus: "pending",
          });
        });

        await batch.commit();

        totalUpdated += snap.size;
        setUpdatedCount(totalUpdated);
        setLog(
          `Batch ${loops} OK: ${snap.size} docs mis à jour (total: ${totalUpdated})`
        );

        lastDoc = snap.docs[snap.docs.length - 1];

        // Fin si moins que PAGE_SIZE
        if (snap.size < PAGE_SIZE) break;
      }

      setLog((p) => `${p}\n✅ Terminé. Total mis à jour: ${totalUpdated}`);
    } catch (e) {
      console.error(e);
      setLog(`❌ Erreur: ${e?.code || ""} ${e?.message || String(e)}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 700 }}>
      <h3>Mettre en pending les produits "Dollar Store"</h3>

      <button onClick={run} disabled={loading}>
        {loading ? "Mise à jour en cours..." : "Lancer la mise à jour"}
      </button>

      <div style={{ marginTop: 12 }}>
        <b>Mis à jour:</b> {updatedCount}
      </div>

      <pre style={{ marginTop: 12, background: "#111", color: "#0f0", padding: 12 }}>
        {log}
      </pre>
    </div>
  );
}
